<div class="add-customer-form" #addCustomerForm>
  <form #addCustomerForm="ngForm">

    <!-- Icons for customer add from vehicle -->
    <div class="icon-bar-vehicle" *ngIf="openFrom === 'add-vehicle'">
      <div class="icon customer-icon mt-35 active">
        <i class="fal fa-user-tie font-400"></i>
      </div>
      <div class="icon vehicle-icon mt-20">
        <i class="fal fa-car"></i>
      </div>
    </div>

    <!-- Icons for customer add from appointment -->
    <div class="icon-bar" *ngIf="openFrom === 'add-appointment'">
      <div class="icon calendar-icon">
        <i class="fal fa-calendar-day"></i>
      </div>
      <div class="icon customer-icon active">
        <i class="fal fa-user-tie font-400"></i>
      </div>
      <div class="icon vehicle-icon">
        <i class="fal fa-car"></i>
      </div>
      <div class="icon task-icon">
        <i class="fal fa-tasks"></i>
      </div>
      <div class="icon user-icon">
        <i class="fal fa-user-hard-hat"></i>
      </div>
      <div class="icon user-note">
        <i class="fal fa-sticky-note"></i>
      </div>
    </div>

    <div
      [ngClass]="{'customer-form-padding mt-10': openFrom === 'add-customer', 'customer-form-padding-other': openFrom !== 'add-customer'}">

      <div class="ui-g-12 p-zero pl-0 mt-3 customer-type-switch">
        <app-switch-button id="customer-type-switch" valueField="value" paddingClass="p-1" [fontSize]="14"
          [showselectedCircle]="false" [value]="customer?.customerType" [showIcons]="true" [options]="customerTypes"
          (appChange)="handleChange('customerType', $event)">
        </app-switch-button>
      </div>

      <!-- First name & Last name -->
      <div class="ui-g-12 p-zero pl-0 mt-30" *ngIf="customer?.customerType?.value === 'customer'">
        <div class="ui-g-2 p-0 height-34">
          <app-input id="first-name" validationId="error-first-name" placeholder="First name*"
            [errorMessage]="validate.firstName" [isInvalid]="validate.firstName" [value]="customer.firstName"
            [floatingLabel]="true" [autoFocus]="true" [maxLength]="25" (appChange)="handleChange('firstName', $event)"
            (appFocus)="handleFocus('firstName')" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="last-name" validationId="error-last-name" placeholder="Last name*"
            [errorMessage]="validate.lastName" [isInvalid]="validate.lastName" [value]="customer.lastName"
            [floatingLabel]="true" [maxLength]="25" (appChange)="handleChange('lastName', $event)"
            (appFocus)="handleFocus('lastName')" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <!-- Company name & Display name -->
        <div class="ui-g-3 p-0 pl-4 height-34" *ngIf="customer?.customerType?.value === 'customer'">
          <app-auto-complete id="company-name-dropdown" listId="company-name-dropdown-list" label="Company name"
            placeholder="Company name" field="name" scrollHeight="180px" theme="primary" editableItemIdKey="_id"
            editFieldLabel="Create company" [floatingLabel]="true" [hasEditableField]="true" [maxLength]="75"
            [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
            [hasStaticUnassignedFiled]="false" [suggestions]="companiesSuggestions" [listItemFontSize]="14"
            [fontSize]="14" [value]="customer?.companyName?.name || ''" (appUpdateItem)="onUpdateCompany($event)"
            (appSelect)="handleChange('companyName', $event)" (appSave)="handleSaveCompany($event)"
            (appCompletedMethod)="handleSearchCompany($event)" (appClear)="handleClearSearch()" (appChange)="onFieldChange($event)">
            <ng-template let-item let-editItem="editItem" appTemplate="item">
              <div class="tag-item flex-between-center">
                <div>
                  <span>{{ item?.name }}</span>
                </div>

                <div class="tag-item-action flex-end-center">
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <div class="ui-g-4 p-0 pl-4 height-34 pl-15" *ngIf="customer?.customerType?.value === 'customer'">
          <app-input id="display-name" validationId="error-display-name" placeholder="Display name*"
            [errorMessage]="validate.fullNameQBO" [isInvalid]="validate.fullNameQBO || !isQboFullNameUniqe"
            [value]="customer.fullNameQBO" [floatingLabel]="true" [maxLength]="50"
            (appChange)="handleChange('fullNameQBO', $event)" (appFocus)="handleFocus('fullNameQBO')" (appChange)="onFieldChange($event)"></app-input>
        </div>
      </div>


      <!-- Fleet name & Display name -->
      <div class="ui-g-12 p-zero pl-0 mt-30" *ngIf="customer?.customerType?.value === 'fleet'">
        <div class="ui-g-12 pr-15 mb-30" *ngIf="isMyFleetCenterEnabled">
          <button class="my-fleet-center-btn" (click)="handleOpenFleetCustomer()">
            <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1" />
            Create customer with MyFleetCenter
          </button>
        </div>

        <div class="ui-g-6 pr-15">
          <app-input id="fleet-name" validationId="error-fleet-name" placeholder="Fleet name*"
            [errorMessage]="validate.firstName" [isInvalid]="validate.firstName" [value]="customer.firstName"
            [floatingLabel]="true" [maxLength]="75" (appChange)="handleChange('firstName', $event)"
            (appFocus)="handleFocus('firstName')" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <div class="ui-g-4 pl-15" *ngIf="isMyFleetCenterEnabled">
          <app-input id="fleet-number" validationId="error-fleet-number" placeholder="Fleet number"
            [value]="customer.fleetNumber" [floatingLabel]="true" [maxLength]="75"
            (appChange)="handleChange('fleetNumber', $event)" (appFocus)="handleFocus('fleetNumber')" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <div class="ui-g-2 pl-15 pb-0 pt-0" *ngIf="isMyFleetCenterEnabled">
          <div class="font-gray-65 font-400 font-14">Fleet type</div>
          <div class="my-fleet-type-badge">Local</div>
        </div>

        <div class="ui-g-6" [ngClass]="isMyFleetCenterEnabled ? 'pr-15 mt-3':'pl-15'">
          <app-input id="display-name" validationId="error-display-name" placeholder="Display name*"
            [errorMessage]="validate.fullNameQBO" [isInvalid]="validate.fullNameQBO || !isQboFullNameUniqe"
            [value]="customer.fullNameQBO" [floatingLabel]="true" [maxLength]="75"
            (appChange)="handleChange('fullNameQBO', $event)" (appFocus)="handleFocus('fullNameQBO')" (appChange)="onFieldChange($event)"></app-input>
        </div>

        <div class="ui-g-6 pl-15 mt-3" *ngIf="isMyFleetCenterEnabled">
          <app-input id="company-name" validationId="error-company-name" placeholder="Company"
            [value]="customer.companyName" [floatingLabel]="true" [maxLength]="75"
            (appChange)="handleChange('companyName', $event)" (appFocus)="handleFocus('companyName')" (appChange)="onFieldChange($event)"></app-input>
        </div>
      </div>

      <div class="ui-g-12 p-0 pl-0 mt-3" *ngIf="nameSuggestions?.length && !isQboFullNameUniqe">
        <div class="flex-start-center">
          <p class="mb-0 customer-name-suggestion" (click)="selectNameSuggestion(name)"
            *ngFor="let name of nameSuggestions">
            {{name}}
          </p>
        </div>
      </div>

      <!-- Phone -->
      <div class="ui-g-12 p-zero pl-0 mt-30" *ngFor="let phone of customer?.phones; let phoneIndex = index">
        <div class="ui-g-2 p-0 height-34">
          <app-dropdown id="phone-type-{{phoneIndex}}" listId="phone-list-type-{{phoneIndex}}" placeholder="Type"
            theme="primary" field="label" [hasError]="errors.phones[phoneIndex]?.contactType"
            [value]="phone?.contactType" [errorMessage]="errors.phones[phoneIndex]?.contactType" [fontSize]="14"
            [listItemFontSize]="13" [floatingLabel]="true" [options]="phoneTypes" [isDropdownIconVisible]="true"
            (appSelect)="handleMultiChange('phones', 'contactType', phoneIndex, $event)" (appChange)="onFieldChange($event)">
          </app-dropdown>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="phone-{{phoneIndex}}" validationId="error-phone-{{phoneIndex}}" mask="(000) 000-0000"
            [placeholder]="handleAddAsterisk(phone)" [value]="phone.value"
            [isInvalid]="errors.phones[phoneIndex]?.value" [errorMessage]="errors.phones[phoneIndex]?.value"
            [floatingLabel]="true" [tooltipIconClass]="handleTooltipClass(phone)" tooltipIconPosition="right"
            [tooltipIconText]="phone.tooltipText" tooltipStyleClass="primary-contact-tooltip"
            (appChange)="handleMultiChange('phones', 'value', phoneIndex, $event)"
            (appFocus)="handleMultiFocus('phones', 'value', phoneIndex, true)"
            (appBlur)="handleMultiFocus('phones', 'value', phoneIndex, false)" (appChange)="onFieldChange($event)"></app-input>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="phone-label-{{phoneIndex}}" validationId="error-phone-label-{{phoneIndex}}" placeholder="Label"
            [value]="phone.label" [floatingLabel]="true" [isInvalid]="errors.phones[phoneIndex]?.label"
            [errorMessage]="errors.phones[phoneIndex]?.label"
            (appChange)="handleMultiChange('phones', 'label', phoneIndex, $event)"
            (appFocus)="handleMultiFocus('phones', 'label', phoneIndex, true)"
            (appBlur)="handleMultiFocus('phones', 'label', phoneIndex, false)" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <div class="ui-g-4 p-0 pl-4 height-34">
          <div class="ui-g-12 p-0 pt-2">
            <div class="ui-g-6 p-0 flex-column height-34 position-relative flex-end-start pb-2">
              <p class="m-0 floating-label font-seconday">
                Primary

                <i class="contact-status-tooltip fal fa-info-circle text-dark font-45"
                  pTooltip="Choose mobile no. as primary contact as all SMS will be sent to this number"
                  tooltipPosition="top"></i>
              </p>

              <app-radio-button id="phone-primary-{{phoneIndex}}" name="phone-primary" label="Primary"
                styleClassLabel="font-seconday" [selectedValue]="phone?.isPrimary"
                [ngClass]="{'not-allowed': !phone?.isActive || phone?.contactType?.value === 'landline' || !phone?.value}"
                [disabled]="!phone?.isActive || phone?.contactType?.value === 'landline' || !phone?.value"
                [value]="true" (appChange)="handleMultiChange('phones', 'isPrimary', phoneIndex, $event)" (appChange)="onFieldChange($event)">
              </app-radio-button>
            </div>

            <div class="ui-g-4 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <p class="m-0 floating-label font-seconday">Active</p>

              <app-switch-pill id="phone-active-{{phoneIndex}}" position="end" [fontSize]="14"
                [isActive]="phone.isActive" [disabled]="phone?.isPrimary" [label]="phone.isActive ? 'Yes' : 'No'"
                (appChange)="handleMultiChange('phones', 'isActive', phoneIndex, $event)">
              </app-switch-pill>
            </div>

            <div class="ui-g-2 p-0 height-34 position-relative d-flex justify-content-end pb-1 pl-3">
              <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!phone?.isPrimary && phoneIndex" pTooltip="
              Delete" tooltipPosition="top" (click)="handleDeleteContact('phones', phoneIndex)" (appChange)="onFieldChange($event)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Add new phone -->
      <div class="ui-g-12 p-zero pl-0 mt-2" *ngIf="customer?.phones.length < 5">
        <span class="m-0 flex-start-center font-primary pointer width-fit-content" id="add-another-phone"
          (click)="handleAddAnother('phone')">
          <i class="fas fa-plus-circle pr-1"></i>
          <span class="font-600">Add another phone</span>
        </span>
      </div>

      <!-- Emails -->
      <div class="ui-g-12 p-zero pl-0 mt-30" *ngFor="let email of customer?.emails; let emailIndex = index">
        <div class="ui-g-2 p-0 height-34">
          <app-dropdown id="email-type-{{emailIndex}}" listId="email-list-type-{{emailIndex}}" placeholder="Type"
            theme="primary" field="label" [hasError]="errors.emails[emailIndex]?.contactType" [value]="{label: 'Email'}"
            [errorMessage]="errors.emails[emailIndex]?.contactType" [fontSize]="14" [listItemFontSize]="13"
            [floatingLabel]="true" [options]="[]" [disabled]="true" [isDropdownIconVisible]="true"
            (appSelect)="handleMultiChange('emails', 'contactType', emailIndex, $event)">
          </app-dropdown>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="email-{{emailIndex}}" validationId="error-email-{{emailIndex}}"
            [placeholder]="handleAddAsterisk(email)" [errorMessage]="errors.emails[emailIndex]?.value"
            [isInvalid]="errors.emails[emailIndex]?.value" [value]="email.value" [floatingLabel]="true"
            [maxLength]="253" [tooltipIconClass]="handleTooltipClass(email)" tooltipIconPosition="right"
            [tooltipIconText]="email.tooltipText" tooltipStyleClass="primary-contact-tooltip"
            (appChange)="handleMultiChange('emails', 'value', emailIndex, $event)"
            (appFocus)="handleMultiFocus('emails', 'value', emailIndex, true)"
            (appBlur)="handleMultiFocus('emails', 'value', emailIndex, false)" (appChange)="onFieldChange($event)">
          </app-input>
        </div>

        <div class="ui-g-3 p-0 pl-4 height-34">
          <app-input id="email-label-{{emailIndex}}" validationId="error-email-label-{{emailIndex}}" placeholder="Label"
            [value]="email.label" [floatingLabel]="true" [errorMessage]="errors.emails[emailIndex]?.label"
            [isInvalid]="errors.emails[emailIndex]?.label"
            (appChange)="handleMultiChange('emails', 'label', emailIndex, $event)"
            (appFocus)="handleMultiFocus('emails', 'label', emailIndex, true)"
            (appBlur)="handleMultiFocus('emails', 'label', emailIndex, false)" (appChange)="onFieldChange($event)"></app-input>
        </div>

        <div class="ui-g-4 p-0 pl-4 height-34">
          <div class="ui-g-12 p-0 pt-2">
            <div class="ui-g-6 p-0 flex-column height-34 position-relative flex-end-start pb-2">
              <p class="m-0 floating-label">
                Primary
                <i class="contact-status-tooltip fal fa-info-circle text-dark font-45"
                  pTooltip="Choose primary email address. All communication by default will be sent to primary email address"
                  tooltipPosition="top"></i>
              </p>

              <app-radio-button id="email-primary-{{emailIndex}}" name="email-primary" label="Primary"
                styleClassLabel="font-seconday" [selectedValue]="email?.isPrimary"
                [ngClass]="{'not-allowed': !email?.isActive|| !email?.value}"
                [disabled]="!email?.isActive|| !email?.value" [value]="true"
                (appChange)="handleMultiChange('emails', 'isPrimary', emailIndex, $event)">
              </app-radio-button>
            </div>

            <div class="ui-g-4 p-0 flex-column height-34 position-relative flex-end-start pb-1 pl-3">
              <p class="m-0 floating-label">Active</p>

              <app-switch-pill id="email-active-{{emailIndex}}" position="end" [fontSize]="14"
                [isActive]="email.isActive" [disabled]="email?.isPrimary" [label]="email.isActive ? 'Yes' : 'No'"
                (appChange)="handleMultiChange('emails', 'isActive', emailIndex, $event)" (appChange)="onFieldChange($event)">
              </app-switch-pill>


            </div>
            <div class="ui-g-2 p-0 height-34 position-relative d-flex justify-content-end pb-1 pl-3">
              <i class="fal fa-trash delete-btn font-gray-45 p-2" *ngIf="!email?.isPrimary && emailIndex"
                pTooltip="Delete" tooltipPosition="top" (click)="handleDeleteContact('emails', emailIndex)"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Add new email -->
      <div class="ui-g-12 p-zero pl-0 mt-2 new-emails" *ngIf="customer?.emails.length < 5">
        <span class="m-0 flex-start-center font-primary pointer width-fit-content" id="add-another-email"
          (click)="handleAddAnother('email')">
          <i class="fas fa-plus-circle pr-1"></i>
          <span class="font-600">Add another email</span>
        </span>
      </div>

      <!-- Communication preferrence -->
      <div class="ui-g-12 p-zero pl-0 mt-30 mb-3 d-flex align-items-center">
        <div class="ui-g-3">
          <p class="field-side-label padding-zero font-14 mb-0" id="update-communication-preference">Communication
            preference</p>
          <div class="pl-2">
            <span class="pr-4">
              <app-checkbox inputId="phone-checkbox" label="Mobile" [isChecked]="contactOnPhone"
                [disabled]="isPhoneDisabled" (appChange)="handleEmailPhoneCheckboxChange('contactOnPhone', $event)"
                id="update-communication-preference-email"></app-checkbox>
            </span>
            <span>
              <app-checkbox inputId="email-checkbox" label="Email" [isChecked]="contactOnEmail"
                id="update-communication-preference-mobile" [disabled]="isEmailDisabled"
                (appChange)="handleEmailPhoneCheckboxChange('contactOnEmail', $event)"></app-checkbox>
            </span>
          </div>
        </div>
        <div class="pref-language ui-g-3 p-0 pr-4 pl-2" *ngIf="companyLocalization">
          <p class="mb-0">Preferred Language</p>
          <div class="flex-start-center">
            <span class="pr-1 radio-inline">
              <app-radio-button [selectedValue]="currentLang" label="English" value="en"
                (appChange)="switchLanguage('en')"></app-radio-button>
            </span>

            <span class="pr-1 ml-4">
              <app-radio-button [selectedValue]="currentLang" label="French" value="fr"
                (appChange)="switchLanguage('fr')"></app-radio-button>
            </span>
          </div>
        </div>

        <div *ngIf="isChargeAccountEnabled" class="ui-g-2 p-0 mt-25">
          <div
            class="custom-checkbox-preferred customer-add-preferrence height-34 flex-column flex-end-start pb-2 position-relative">
            <span class="floating-label cursor-default mb-0 font-11">Charge Account
              <i class="fal fa-info-circle font-gray-45" [pTooltip]="chargeAccountTogleTooltip" tooltipPosition="top"
                [escape]="false" tooltipStyleClass="ticket-tooltip modifier pinned"></i>
            </span>

            <div class="custom-checkbox-align">
              <app-switch-pill id="charge-account" label="" position="end"
                [isActive]="customer?.customerType?.value === 'fleet' ? true : false"
                [disabled]="customer?.customerType?.value === 'fleet' || !isArAccountManagement"
                (appChange)="handleChange('chargeAccountEnable', $event)" [fontSize]="12"></app-switch-pill>
            </div>
          </div>
        </div>

        <div class="ui-g-7 p-0 pl-0 pl-lg-4">
          <app-textarea textAreaId="Vnotes" validationId="error-notes" type="text" theme="primary" placeholder="Notes"
            [rows]="1" [fontSize]="14" [floatingLabel]="true" [autoGrow]="true" [maxAutoGrowHeight]="68"
            [value]="customer?.notes" [isInvalid]="validate?.notes" [errorMessage]="validate?.notes"
            (appChange)="handleChange('notes', $event)">
          </app-textarea>
        </div>
      </div>

      <div class="ui-g-12 p-zero pl-0 mt-2" *ngIf="customer?.customerType?.value === 'fleet'">
        <p class="m-0 font-secondary-800 font-bold font-16 fleet-setting-heading-border pb-2 mb-3">Fleet override</p>
        <custom-fleet-setting [displayName]="customer.fullNameQBO" [errors]="errors"
          (handleDataChange)="updateFleetSettings($event)"></custom-fleet-setting>
      </div>

      <!-- Address -->
      <div class="ui-g-12 p-zero mt-28">
        <div class="ui-g-12 p-point25rem">
          <app-input *ngIf="!isGoogleAddressSearchEnabled" id="address-1"
            [label]="fieldsPlaceholder?.primaryAddress?.addLine1"
            [placeholder]="fieldsPlaceholder?.primaryAddress?.addLine1" [errorMessage]="validate.address?.addLine1"
            [isInvalid]="validate.address?.addLine1" [value]="customer.address?.addLine1" [floatingLabel]="true"
            [maxLength]="160" (appChange)="handleChange('address-addLine1', $event)"
            (appFocus)="handleFocus('address.addLine1')"></app-input>
          <app-auto-complete *ngIf="isGoogleAddressSearchEnabled" id="address-1" textAreaId="address-1"
            listId="list-address-1" field="name" theme="inline" scrollHeight="160px"
            [label]="fieldsPlaceholder?.primaryAddress?.addLine1"
            [placeholder]="fieldsPlaceholder?.primaryAddress?.addLine1" [floatingLabel]="true"
            [errorMessage]="validate.address?.addLine1" [isInvalid]="validate.address?.addLine1"
            [isLoading]="loader.address?.addLine1" [isDropdownIconVisible]="true" [fontSize]="14"
            [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.address?.addLine1"
            [suggestions]="addressResults?.address" [isTriggerChangeOnPaste]="false"
            (appCompletedMethod)="handleAddressSearch($event, customer.address, 'address')"
            (appSelect)="handleAddressSelect($event, 'address')" (appFocus)="handleFocus('address.addLine1')"
            (appClear)="handleAddressClear('address')" (appChange)="handleAddressChange($event, 'address')">
          </app-auto-complete>
        </div>
      </div>

      <!-- Zip code & City -->
      <div class="ui-g-12 p-zero mt-28" #primaryAddress>
        <div class="ui-g-2 pr-15 p-point25rem">
          <app-input id="zip-1" validationId="error-zip-1" [label]="fieldsPlaceholder?.primaryAddress?.zip"
            [placeholder]="fieldsPlaceholder?.primaryAddress?.zip" [errorMessage]="validate.address?.zip"
            [isInvalid]="validate.address?.zip" [tooltipIconClass]="isZipCodeLoading.address && 'fal fa-spinner rotate'"
            [value]="customer.address?.zip" [floatingLabel]="true" [maxLength]="7"
            (appChange)="handleChange('address-zip', $event)" (appFocus)="handleFocus('address.zip')"
            (appBlur)="zipChange($event, 'address')"></app-input>
        </div>

        <div class="ui-g-4 p-zero">
          <div class="city-auto-complete-align">
            <app-auto-complete id="city-1" textAreaId="city-1" listId="list-city-1" field="city" theme="inline"
              scrollHeight="160px" [label]="fieldsPlaceholder?.primaryAddress?.city"
              [rightIcon]="loader?.address?.address? 'fal fa-spinner rotate': ''"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.city" [floatingLabel]="true"
              [isDropdownIconVisible]="true" [isSetPositionDynamically]="true" [fontSize]="14"
              [errorMessage]="validate.address?.city" [isInvalid]="validate.address?.city" [closeOnSelection]="true"
              [value]="customer.address?.city" [suggestions]="addressCityResults"
              (appSelect)="handleCitySelect($event, 'address')"
              (appCompletedMethod)="handleCitySearch($event, customer.address, 'address')"
              (appFocus)="handleFocus('address.city')" (appClear)="handleCityClear('address')">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.city}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <div class="ui-g-3 p-zero">
          <div class="state-auto-complete-align">
            <app-auto-complete id="state-1" textAreaId="state-1" listId="list-state-1" field="name" theme="inline"
              scrollHeight="160px" [label]="fieldsPlaceholder?.primaryAddress?.state"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.state" [floatingLabel]="true"
              [errorMessage]="validate.address?.state" [isInvalid]="validate.address?.state"
              [isLoading]="loader.address?.state" [isDropdownIconVisible]="true" [fontSize]="14"
              [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.address?.state"
              [suggestions]="stateResults?.address"
              (appCompletedMethod)="handleStateSearch($event, customer.address, 'address')"
              (appSelect)="handleStateSelect($event, 'address')" (appFocus)="handleFocus('address.state')"
              (appClear)="handleStateClear('address')">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.state}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <div class="ui-g-3 p-zero">
          <div class="country-auto-complete-align">
            <app-dropdown id="country-1" listId="country-list-1" class="width-100p" theme="primary" field="name"
              position="top" [label]="fieldsPlaceholder?.primaryAddress?.country"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.country" [hasError]="validate.address?.country"
              [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true" [setPositionDynamically]="false"
              [errorMessage]="validate.address?.country" [options]="countryOptions"
              [value]="{name: customer.address?.country}" [isDropdownIconVisible]="true"
              (appOpenDropdown)="handleFocus('address.country')"
              (appSelect)="handleCountrySelect($event.value, 'address')">
            </app-dropdown>
          </div>
        </div>
      </div>

      <div [@toggleBox]="isOpen ? 'open' : 'closed'">
        <span *ngIf="isOpen">
          <!-- Address -->
          <div class="ui-g-12 p-zero mt-28">
            <div class="ui-g-12 p-point25rem">
              <app-input *ngIf="!isGoogleAddressSearchEnabled" id="address-2"
                [placeholder]="fieldsPlaceholder?.secondaryAddress?.addLine1"
                [errorMessage]="validate.businessAddress?.addLine1" [isInvalid]="validate.businessAddress?.addLine1"
                [value]="customer.businessAddress?.addLine1" [floatingLabel]="true" [maxLength]="160"
                (appChange)="handleChange('businessAddress-addLine1', $event)"
                (appFocus)="handleFocus('businessAddress.addLine1')"></app-input>
              <app-auto-complete *ngIf="isGoogleAddressSearchEnabled" id="address-2" textAreaId="address-2"
                listId="list-address-2" field="name" theme="inline" scrollHeight="160px"
                [label]="fieldsPlaceholder?.secondaryAddress?.addLine1"
                [placeholder]="fieldsPlaceholder?.secondaryAddress?.addLine1" [floatingLabel]="true"
                [errorMessage]="validate.businessAddress?.addLine1" [isInvalid]="validate.businessAddress?.addLine1"
                [isLoading]="loader.businessAddress?.addLine1" [isDropdownIconVisible]="true" [fontSize]="14"
                [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.businessAddress?.addLine1"
                [suggestions]="addressResults?.businessAddress" [isTriggerChangeOnPaste]="false"
                (appCompletedMethod)="handleAddressSearch($event, customer.businessAddress, 'businessAddress')"
                (appSelect)="handleAddressSelect($event, 'businessAddress')"
                (appFocus)="handleFocus('businessAddress.addLine1')" (appClear)="handleAddressClear('businessAddress')"
                (appChange)="handleAddressChange($event, 'businessAddress')"></app-auto-complete>
            </div>
          </div>

          <!-- Zip code & City -->
          <div class="ui-g-12 p-zero mt-28">
            <div class="ui-g-2 pr-15 p-point25rem">
              <app-input id="zip-2" validationId="error-zip-2" [placeholder]="fieldsPlaceholder?.secondaryAddress?.zip"
                [errorMessage]="validate.businessAddress?.zip" [isInvalid]="validate.businessAddress?.zip"
                [value]="customer.businessAddress?.zip"
                [tooltipIconClass]="isZipCodeLoading.businessAddress && 'fal fa-spinner rotate'" [floatingLabel]="true"
                [maxLength]="7" (appChange)="handleChange('businessAddress-zip', $event)"
                (appFocus)="handleFocus('businessAddress.zip')"
                (appBlur)="zipChange($event, 'businessAddress')"></app-input>
            </div>

            <div class="ui-g-4 p-zero">
              <div class="city-auto-complete-align">
                <app-auto-complete id="city-2" textAreaId="city-2" listId="list-city-2" label="City" field="city"
                  theme="inline" scrollHeight="160px" [placeholder]="fieldsPlaceholder?.secondaryAddress?.city"
                  [floatingLabel]="true" [isDropdownIconVisible]="true" [fontSize]="14"
                  [errorMessage]="validate.businessAddress?.city" [isInvalid]="validate.businessAddress?.city"
                  [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.businessAddress?.city"
                  [suggestions]="bAddressCityResults" (appSelect)="handleCitySelect($event, 'businessAddress')"
                  (appCompletedMethod)="handleCitySearch($event, customer.businessAddress, 'businessAddress')"
                  (appClear)="handleCityClear('businessAddress')">
                  <ng-template let-item appTemplate="item">
                    <div class="flex-between-center">
                      <div class="font-14">
                        {{item.city}}, {{item?.stateCode}}
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
            </div>

            <div class="ui-g-3 p-zero">
              <div class="state-auto-complete-align">
                <app-auto-complete id="state-2" textAreaId="state-2" listId="list-state-2" label="State" field="name"
                  theme="inline" scrollHeight="160px" [placeholder]="fieldsPlaceholder?.secondaryAddress?.state"
                  [floatingLabel]="true" [errorMessage]="validate.businessAddress?.state"
                  [isInvalid]="validate.businessAddress?.state" [isDropdownIconVisible]="true" [fontSize]="14"
                  [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.businessAddress?.state"
                  [isLoading]="loader.businessAddress?.state" [suggestions]="stateResults?.businessAddress"
                  (appSelect)="handleStateSelect($event, 'businessAddress')"
                  (appCompletedMethod)="handleStateSearch($event, customer.businessAddress, 'businessAddress')"
                  (appFocus)="handleFocus('businessAddress.state')" (appClear)="handleStateClear('businessAddress')">
                  <ng-template let-item appTemplate="item">
                    <div class="flex-between-center">
                      <div class="font-14">
                        {{item.state}}, {{item?.stateCode}}
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
            </div>

            <div class="ui-g-3 p-zero">
              <div class="country-auto-complete-align">
                <app-dropdown id="country-2" listId="country-list-2" class="width-100p" theme="primary" field="name"
                  position="top" [placeholder]="fieldsPlaceholder?.secondaryAddress?.country"
                  [hasError]="validate.businessAddress?.country" [fontSize]="14" [listItemFontSize]="14"
                  [floatingLabel]="true" [setPositionDynamically]="false"
                  [errorMessage]="validate.businessAddress?.country" [options]="countryOptions"
                  [value]="{name: customer.businessAddress?.country}" [isDropdownIconVisible]="true"
                  (appSelect)="handleCountrySelect($event.value, 'businessAddress')">
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- Tax exempt & tax exempt reasons -->
          <div class="ui-g-12 p-zero mt-28">
            <div class="ui-g-4 p-0">
              <div class="flex-column position-relative">
                <p class="cursor-default mb-0 font-12 font-gray-65 position-absolute tax-exempt-label">Tax exempt</p>

                <div class="flex-start-center ">
                  <app-switch-pill id="tax-exempt" label="" position="end" [isActive]="customer.taxExempt"
                    (appChange)="handleChange('taxExempt', $event)" [fontSize]="12"></app-switch-pill>

                  <span class="pl-2 font-gray-35">
                    {{customer.taxExempt? 'Yes': 'No' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="ui-g-8 p-0">
              <div class="city-auto-complete-align">
                <app-dropdown *ngIf="customer?.taxExempt" id="tax-exempt-reason" listId="tax-exempt-reason-list"
                  class="width-100p" placeholder="Reason for tax-exemption*" theme="primary" field="reason"
                  [hasError]="validate?.taxExemptReason" [errorMessage]="validate?.taxExemptReason" [fontSize]="14"
                  [listItemFontSize]="14" [floatingLabel]="true" [options]="qboTaxExemptReasons"
                  [value]="customer?.taxExemptReason" [isDropdownIconVisible]="true"
                  (appSelect)="handleChange('taxExemptReason', $event)">
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- Customer tags -->
          <div class="ui-g-12 mt-20 p-zero tag-list-alignment">
            <app-tags-list buttonId="customer-add-tags" addTagTitle="Add tags" [tags]="customerTags"
              [type]="tagTypeCustomer" [selectedTags]="customer?.tags" (appTagDeleted)="handleTagDelete($event)" [fontSize]="11" [hasCreateOption]="true"
              [isDeleteable]="true" (appSelect)="onTagSelect($event)" (appDelete)="onTagDelete($event)"
              (appCreateTag)="onTagCreate($event)" (appShowSuggestion)="onTagFocus()">
            </app-tags-list>
          </div>
        </span>
      </div>

      <div class="ui-g-12">
        <div class="show-more-icon show-more-pointer-custom mt-2 mb-20">
          <span class="pointer" *ngIf="!isOpen" (click)="toggle()">
            <i class="fal fa-angle-down"></i> Show More
          </span>
          <span class="pointer" *ngIf="isOpen" (click)="toggle()">
            <i class="fal fa-angle-up"></i> Show Less
          </span>
        </div>
      </div>
    </div>
  </form>
</div>
